import React, { useState, useEffect, useRef } from "react";
import { Row, Col } from 'reactstrap';
import { withStyles } from '@material-ui/core';
import * as Constants from '../../Pages/Constants';
import { FormattedMessage } from 'react-intl';
import DatePicker from 'react-date-picker'
import ValidationPopup from '../../Popup/ValidationPopup.js';
import PatientFunctionsGetter from "../../Controller/getSQLPatientFunctions.js";

import Utils from '../Common/Utils.js';

const INSDataDisplay = (props) => {

  const { classes } = props;

  let workingOnCancel = false //pass to true if trying to deal with the cancel modification button

  const [firstname, setFirstname] = useState(props.profileData.Patient_Data.firstname);
  const [lastname, setLastname] = useState(props.profileData.Patient_Data.lastname);
  const [birthdate, setBirthdate] = useState(new Date(props.profileData.Patient_Data.birthdate));

  const savedPatient = props.profileData;
  const [submitted, setsubmitted] = useState(false);

  const [message, setmessage] = useState("");
  const [displayValidationPopup, setDisplayValidationPopup] = useState(false);

  // ###### HANDLE VALUE CHANGE FUNCTIONS ######

  //Function to handle firstname value
  const handleChangeFirstname = (event) => {
    setFirstname(event.target.value);
    props.setChangeOngoing(true)
  }

  //Function to handle lastname value
  const handleChangeLastname = (event) => {
    setLastname(event.target.value);
    props.setChangeOngoing(true)
  }

  //Function to handle birthdate value
  const handleChangeBirthdate = (birthdate) => {
    setBirthdate(new Date(birthdate));
    props.setChangeOngoing(true)
  }

  //Function to handle birthdate value 
  const handleChangeBirthdateNoDay = (new_birthdate) => {
    let new_date = new Date(birthdate)
    new_date.setMonth(new_birthdate.target.value.split('-')[1] - 1)
    new_date.setFullYear(new_birthdate.target.value.split('-')[0])
    setBirthdate(new_date);
    props.setChangeOngoing(true)
  };

  const handleValidationPopupDisplay = () => {
    setDisplayValidationPopup(!displayValidationPopup)
  }

  const checkINSData = () => {
      let ret = true
      if (props.accountInformation.anonymised_patient === 1 ||
          (props.profileData.Patient_Data.INS_Data.NumIdentifiant === undefined
          || props.profileData.Patient_Data.INS_Data.NumIdentifiant === ""
          || props.profileData.Patient_Data.INS_Data.OID === undefined
          || props.profileData.Patient_Data.INS_Data.OID === ""
          || props.profileData.Patient_Data.INS_Data.Cle === undefined
          || props.profileData.Patient_Data.INS_Data.Cle === ""
          || props.profileData.Patient_Data.INS_Data.NomNaissance === undefined
          || props.profileData.Patient_Data.INS_Data.PrenomNaissance === undefined
          || props.profileData.Patient_Data.INS_Data.DateNaissance === undefined
          || props.profileData.Patient_Data.INS_Data.Sex === undefined
          || props.profileData.Patient_Data.INS_Data.LieuNaissance === undefined)
         ) {
          ret = false
      }
      return ret
  }

  const restorePatient = () => {
    setFirstname(savedPatient.Patient_Data.firstname);
    setLastname(savedPatient.Patient_Data.lastname);
    setBirthdate(new Date(savedPatient.Patient_Data.birthdate));
  }

  //Function to get patient object to send for update
  const getUpdatedPatient = () => {

    let updated_patient = props.profileData;

    updated_patient.Patient_Data.firstname                = firstname;
    updated_patient.Patient_Data.lastname                 = lastname;
    updated_patient.Patient_Data.birthdate                = Utils.convert_date_to_YMD_string(birthdate);

    if (updated_patient.Patient_Data.alerts.sms_alert === '') {
      updated_patient.Patient_Data.alerts.sms_alert = ['']
    }

    return (updated_patient);
  }

  const isDocaposteUpdated = () => {

    let isDocaposteUpdated = false;

    if(
        (props.profileData.Patient_Data.INS_Data.NumIdentifiant === null || props.profileData.Patient_Data.INS_Data.NumIdentifiant === undefined || props.profileData.Patient_Data.INS_Data.NumIdentifiant === "")
        &&
        (firstname !== props.profileData.Patient_Data.firstname || lastname !== props.profileData.Patient_Data.lastname || Utils.convert_date_to_YMD_string(birthdate) !== props.profileData.Patient_Data.birthdate)
      )
      {
        isDocaposteUpdated = true;
      }

    return isDocaposteUpdated;
  }

  //Function to send updates to Docaposte and SQL
  const updatePatientDeviceAndGateway = async () => {

    let docaposteUpdated = isDocaposteUpdated();

    let updated_patient = getUpdatedPatient();
    let ret;

    if(docaposteUpdated){

        ret = await PatientFunctionsGetter.update_SQL_patient(updated_patient);
        if (ret){
          setmessage(<FormattedMessage id="param.validationChangesConfirm" defaultMessage="Success: These changes will be effective in a few minutes."/>);
          props.setChangeOngoing(false)
        }
        else {
          setmessage(<FormattedMessage id="message.error.params_edit.docaup" defaultMessage="Oups, did not work... (err_code params_edit_docaup)" />);
        }
        // reload data
        if(docaposteUpdated){
          await props.reloadUserAndProfiles();
        }
        else{
          props.updateProfileParameters(updated_patient);
        }

    }

    else{
      if((props.userRole === "admin")||(props.userRole === "staff")){

        ret = await PatientFunctionsGetter.update_SQL_patient(updated_patient);
        if (ret){
          setmessage(<FormattedMessage id="param.validationChangesConfirm" defaultMessage="Success: These changes will be effective in a few minutes."/>);
          props.setChangeOngoing(false)
        }
        else {
          setmessage(<FormattedMessage id="message.error.params_edit.nodoca" defaultMessage="Oups, did not work... (err_code params_edit_nodoca)" />);
        }
        // reload data
        if(deviceConfigChanged){
          await props.reloadUserAndProfiles();
        }
        else{
          props.updateProfileParameters(updated_patient);
        }
      }
      else{
        setmessage("No changes detected!");
      }
    }

    setsubmitted(true);
  }

  //Function to update patient
  const checkParametersUpdate = () => {
      setmessage(<FormattedMessage id="param.validationChangesVerify" defaultMessage="Do you want to apply these changes"/>)
      handleValidationPopupDisplay();
  };


  // ###### RENDER FUNCTIONS ######

  //Function to render ins historic data
  const renderINSHisto = () => {
    if ((props.profileData.Patient_Data.INSHISTO !== undefined)&&(props.profileData.Patient_Data.INSHISTO.IdIndividu !== undefined) ){
        return(
          <div style={{width:"100%"}}>
            <br/>
            <Row style={{display: 'flex', flexDirection:"row", textAlign: 'center', justifyContent: 'center', width:"100%"}}>
              <FormattedMessage id="INSHisto.INShisto" defaultMessage="History : "/>
            </Row>
            <Row style={{display: 'flex', flexDirection:"row", textAlign: 'center', justifyContent: 'center', width:"100%"}}>
              <FormattedMessage id="INSHisto.individualID" defaultMessage="Individual ID : "/>
            <FormattedMessage id="INSHisto.IDNumber" defaultMessage="ID Number : " values={{id: props.profileData.Patient_Data.INSHISTO.IdIndividu.NumIdentifiant}}/>
            <FormattedMessage id="INSHisto.key" defaultMessage="Key : " values={{key: props.profileData.Patient_Data.INSHISTO.IdIndividu.Cle}}/>
            </Row>
            <Row style={{display: 'flex', flexDirection:"row", textAlign: 'center', justifyContent: 'center', width:"100%"}}>
              <FormattedMessage id="INSHisto.startDate" defaultMessage="Start Date : "/>
            {props.profileData.Patient_Data.INSHISTO.DateDeb}
            </Row>
            <Row style={{display: 'flex', flexDirection:"row", textAlign: 'center', justifyContent: 'center', width:"100%"}}>
              <FormattedMessage id="INSHisto.endDate" defaultMessage="End Date : "/>
            {props.profileData.Patient_Data.INSHISTO.DateFin}
            </Row>
          </div>
        )
      }
      else {
        return(null)
      }
  }

  const generateINSDataRow = (id, defaultMessage, data, oid) => {
    return (
      <Row style={{display: 'flex', flexDirection:"row", textAlign: 'center', justifyContent: 'center', width:"100%"}}>
        <Col style={{textAlign:"left", paddingLeft:"5%", paddingRight:0}}>
          <FormattedMessage id={id} defaultMessage={defaultMessage}/>
        </Col>
        <Col style={{textAlign:"left"}}>
          {data}
          {(oid === undefined) ?
            null
            :
            (oid === "1.2.250.1.213.1.4.8") ?
            <FormattedMessage id="INS.NIR" defaultMessage=" (NIR)"/>
            :
            <FormattedMessage id="INS.NIA" defaultMessage=" (NIA)"/>
          }
        </Col>
      </Row>
    )
  }

  //Function to render ins data
  const renderINSData = () => {
    if (checkINSData()) {
      let accountInformation = Utils.ins_format_data(props.profileData.Patient_Data);

  return (
        <div>
          {generateINSDataRow("INS.firstnameDisplayed", "Firstname : ", accountInformation.firstName)}
          {generateINSDataRow("INS.lastnameDisplayed", "Lastname : ", accountInformation.lastName)}
          {(accountInformation.INS_Data.DateNaissance !== undefined && accountInformation.INS_Data.DateNaissance !== "") ?
            generateINSDataRow("INS.birthdate", "Birthdate : ", Utils.convert_date_to_full_date_string(accountInformation.INS_Data.DateNaissance))
              :
              null
          }
          <hr></hr>
          <div style={{width:"100%"}}>
          <Row style={{display: 'flex', flexDirection:"row", textAlign: 'center', justifyContent: 'center', width:"100%"}}>
              <FormattedMessage id="INS.title" defaultMessage="INS data"/>
          </Row>
          <br></br>
              {(accountInformation.INS_Data.NomUtilise !== undefined && accountInformation.INS_Data.NomUtilise !== "") ?
              generateINSDataRow("INS.lastnameused", "Lastname used : ", accountInformation.INS_Data.NomUtilise)
                  :
              generateINSDataRow("INS.lastnameused", "Lastname used : ", accountInformation.INS_Data.NomNaissance)
              }
            {generateINSDataRow("INS.firstfirstname", "First firstname : ", accountInformation.INS_Data.PremierPrenom)}
              {(accountInformation.INS_Data.PrenomUtilise !== undefined && accountInformation.INS_Data.PrenomUtilise !== "") ?
              generateINSDataRow("INS.firstnameused", "Firstname used : ", accountInformation.INS_Data.PrenomUtilise)
        :
              generateINSDataRow("INS.firstnameused", "Firstname used : ", accountInformation.INS_Data.PrenomNaissance)
      }
            {generateINSDataRow("INS.lastname", "Lastname : ", accountInformation.INS_Data.NomNaissance)}
            {generateINSDataRow("INS.firstname", "Firstname : ", accountInformation.INS_Data.PrenomNaissance)}
              {(accountInformation.INS_Data.DateNaissance !== undefined && accountInformation.INS_Data.DateNaissance !== "") ?
              generateINSDataRow("INS.birthdate", "Birthdate : ", Utils.convert_date_to_full_date_string(accountInformation.INS_Data.DateNaissance))
                  :
                  null
              }
              {(accountInformation.Sex !== undefined && accountInformation.Sex !== "") ?
              generateINSDataRow("INS.sex", "Sex : ", Utils.ins_convert_sex(accountInformation.Sex))
                  :
                  null
              }
                  {(accountInformation.INS_Data.NumIdentifiant === undefined || accountInformation.INS_Data.NumIdentifiant === "") ?
            null
            :
              generateINSDataRow("INS.INSNumber", "INS : ", accountInformation.INS_Data.NumIdentifiant, accountInformation.INS_Data.OID)
          }
            {generateINSDataRow("INS.OID", "OID : ", accountInformation.INS_Data.OID)}
            {generateINSDataRow("INS.birthplace", "Birthplace : ", accountInformation.INS_Data.LieuNaissance)}
        </div>
        </div>
      )
    }
    else {
      return (null)
    }
  }

  //Function to render patient identification elements
  const renderPatientIdentification = () => {
    const options = {
      year: 'numeric',
      month: 'long'
    };
    if (!props.accountInformation.anonymised_patient && !checkINSData()) {
      return(
        <div>
          {Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("hepadom")) ?
            generateINSDataRow("INS.identifier", "Identifier : ", firstname)
            :
          <Row>
            <Col>
                <FormattedMessage id="INS.firstnameDisplayed" defaultMessage="Firstname/IPP"/>
            </Col>
            <Col>
                <input type="text" id="firstname" name={props.profileData.Patient_Data.firstname} value={firstname} style={{width: "90%", border: "1px solid gray"}} onChange={handleChangeFirstname}  />
            </Col>
          </Row>
          }
          {Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("hepadom")) ?
            null
            :
          <Row>
            <Col>
                <FormattedMessage id="INS.lastnameDisplayed" defaultMessage="Lastname : " />
            </Col>
            <Col>
                <input type="text" id="lastname" name={props.profileData.Patient_Data.lastname} value={lastname} style={{width: "90%", border: "1px solid gray"}} onChange={handleChangeLastname} />
            </Col>
          </Row>
          }
          {Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("hepadom")) ?
            generateINSDataRow("INS.birthdate", "Birthdate : ", birthdate.toLocaleDateString(undefined, options))
            :
          <Row>
            <Col>
                <FormattedMessage id="INS.birthdate" defaultMessage="Birthdate : "/>
            </Col>
            <Col>
              <DatePicker calendarIcon={null} clearIcon={null} onChange={handleChangeBirthdate} value={new Date(birthdate)} />
            </Col>
        </Row>
          }
        </div>
      )
    }
    else {
      return(
        <div>
        </div>
      )
    }
  }
  return (
    <div style={{width:"100%"}}>
      {renderPatientIdentification()}
      {renderINSData()}
      {renderINSHisto()}
      <div style={{textAlign:"center", position:"relative"}}>
        {workingOnCancel ?
          <button onClick={restorePatient} className="btn btn-danger" disabled={!props.changeOngoing}>
            <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
          </button>
        :
        null
      }
        <b>&emsp;</b>
        {Utils.ins_check_if_data_exist(props.profileData.Patient_Data) && props.accountInformation.readOnly !== true ?
        <button onClick={checkParametersUpdate} className="btn btn-success" disabled={!props.changeOngoing}>
          <FormattedMessage id="button.submit" defaultMessage="Submit" />
        </button>
          :
          null
        }
      </div>
      {displayValidationPopup ?
        <ValidationPopup cancelPopup={handleValidationPopupDisplay} validate={updatePatientDeviceAndGateway} message={message}/>
        :
        null
      }

  </div>
  );
}

export default withStyles(Constants.styles)(INSDataDisplay);
